import React from "react";
import { translate } from "Shared/translate";
import * as styles from "./calculation.scss";
import Price from "./../../Features/Shared/Price";
import { Input } from "Shared/Fields";
import shallowEquals from "Shared/shallow-equals";
import { post } from "Shared/server";
import { pathCombine } from "Shared/url";
import connect from "Shared/connect";
const debounceMs = 500;
class Calculation extends React.Component {
    constructor(props) {
        super(props);
        const portioncost = props.portionCost.current;
        if (!isNaN(props.factor) &&
            !!props.factor &&
            props.factor !== 0 &&
            !!portioncost &&
            portioncost !== 0) {
            const vatpercent = !!isNaN(props.vat) ? 0 : props.vat;
            const costpercent = 100 / props.factor;
            const calcprice = portioncost * props.factor;
            const vat = (calcprice * vatpercent) / 100;
            const customerprice = calcprice + vat;
            this.state = {
                factor: props.factor,
                vatpercent: props.vat,
                proxyfactor: !props.factor
                    ? ""
                    : props.factor.toString().replace(".", ","),
                proxyvatpercent: !props.vat
                    ? ""
                    : props.vat.toString().replace(".", ","),
                costpercent: costpercent,
                calcprice: calcprice,
                vat: Math.round(100 * vat) / 100,
                customerprice: customerprice,
                proxycostpercent: costpercent.toFixed().replace(".", ","),
                proxycalcprice: calcprice.toFixed(2).replace(".", ","),
                proxycustomerprice: customerprice.toFixed(2).replace(".", ","),
            };
        }
        else {
            this.state = {
                factor: props.factor,
                vatpercent: props.vat,
                proxyfactor: !props.factor
                    ? ""
                    : props.factor.toString().replace(".", ","),
                proxyvatpercent: !props.vat
                    ? ""
                    : props.vat.toString().replace(".", ","),
            };
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = !shallowEquals(this.props, nextProps) ||
            !shallowEquals(this.state, nextState);
        if (!shouldUpdate) {
            console.info("Ignoring update to Calculation");
        }
        return shouldUpdate;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        let recalc = false;
        let factor;
        let vatpercent;
        if (nextProps.portionCost !== this.props.portionCost) {
            recalc = true;
            factor = this.state.factor;
            vatpercent = this.state.vatpercent;
        }
        if (nextProps.factor !== this.props.factor ||
            nextProps.vat !== this.props.vat) {
            recalc = true;
            factor = nextProps.factor;
            vatpercent = nextProps.vat;
        }
        if (recalc) {
            if (!isNaN(factor) &&
                !!factor &&
                factor !== 0 &&
                !!nextProps.portionCost.current &&
                nextProps.portionCost.current !== 0) {
                const costpercent = 100 / factor;
                const calcprice = nextProps.portionCost.current * factor;
                const vat = !!isNaN(vatpercent) ? 0 : (calcprice * vatpercent) / 100;
                const customerprice = calcprice + vat;
                this.setState({
                    factor: factor,
                    vatpercent: vatpercent,
                    costpercent: costpercent,
                    calcprice: calcprice,
                    vat: Math.round(100 * vat) / 100,
                    proxyfactor: (Math.round(100 * factor) / 100)
                        .toString()
                        .replace(".", ","),
                    proxyvatpercent: vatpercent.toString().replace(".", ","),
                    customerprice: customerprice,
                    proxycostpercent: costpercent.toFixed().replace(".", ","),
                    proxycalcprice: calcprice.toFixed(2).replace(".", ","),
                    proxycustomerprice: customerprice.toFixed(2).replace(".", ","),
                });
            }
        }
    }
    updateCalculationFields(costpercent, factor, calcprice, vat, customerprice) {
        this.setState({
            costpercent: costpercent,
            factor: Math.round(100 * factor) / 100,
            calcprice: calcprice,
            vat: Math.round(100 * vat) / 100,
            customerprice: customerprice,
        });
        if (!!this.props.isLoggedIn &&
            !!this.props.recipeId &&
            (!!this.state.factor ||
                (!!this.state.vatpercent && this.state.vatpercent !== 12))) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (!!this.props.isLoggedIn &&
                    !!this.props.recipeId &&
                    (!!this.state.factor ||
                        (!!this.state.vatpercent && this.state.vatpercent !== 12))) {
                    post(pathCombine("/recipe", "/updateCalculationFactor"), {
                        recipeId: this.props.recipeId,
                        factor: this.state.factor,
                        vat: !!this.state.vatpercent
                            ? this.state.vatpercent.toString()
                            : "0",
                    });
                    if (!!this.props.onUpdateCalculation) {
                        this.props.onUpdateCalculation(this.state.factor, this.state.vatpercent);
                    }
                }
            }, debounceMs);
        }
    }
    recalculateCostPercent(value) {
        const portioncost = this.props.portionCost.current;
        this.setState({ proxycostpercent: value });
        const costpercent = typeof value === "string" ? parseInt(value, 10) : value;
        if (!!isNaN(costpercent) ||
            !costpercent ||
            costpercent === 0 ||
            !portioncost ||
            portioncost === 0) {
            return;
        }
        const vatpercent = !!isNaN(this.state.vatpercent)
            ? 0
            : this.state.vatpercent;
        const factor = 100 / costpercent;
        const calcprice = portioncost * factor;
        const vat = (calcprice * vatpercent) / 100;
        const customerprice = calcprice + vat;
        this.updateCalculationFields(costpercent, factor, calcprice, vat, customerprice);
        this.setState({
            proxyfactor: (Math.round(100 * factor) / 100)
                .toString()
                .replace(".", ","),
            proxycalcprice: calcprice.toFixed(2).replace(".", ","),
            proxycustomerprice: customerprice.toFixed(2).replace(".", ","),
        });
    }
    recalculateFactor(value) {
        const portioncost = this.props.portionCost.current;
        this.setState({ proxyfactor: value });
        const factor = typeof value === "string" ? parseFloat(value.replace(",", ".")) : value;
        if (!!isNaN(factor) ||
            !factor ||
            factor === 0 ||
            !portioncost ||
            portioncost === 0) {
            return;
        }
        const vatpercent = !!isNaN(this.state.vatpercent)
            ? 0
            : this.state.vatpercent;
        const costpercent = 100 / factor;
        const calcprice = portioncost * factor;
        const vat = (calcprice * vatpercent) / 100;
        const customerprice = calcprice + vat;
        this.updateCalculationFields(costpercent, factor, calcprice, vat, customerprice);
        this.setState({
            proxycostpercent: costpercent.toFixed().replace(".", ","),
            proxycalcprice: calcprice.toFixed(2).replace(".", ","),
            proxycustomerprice: customerprice.toFixed(2).replace(".", ","),
        });
    }
    recalculateCalcPrice(value) {
        const portioncost = this.props.portionCost.current;
        this.setState({ proxycalcprice: value });
        const calcprice = typeof value === "string" ? parseFloat(value.replace(",", ".")) : value;
        if (!!isNaN(calcprice) ||
            !calcprice ||
            calcprice === 0 ||
            !portioncost ||
            portioncost === 0) {
            return;
        }
        const vatpercent = !!isNaN(this.state.vatpercent)
            ? 0
            : this.state.vatpercent;
        const factor = calcprice / portioncost;
        const costpercent = 100 / factor;
        const vat = (calcprice * vatpercent) / 100;
        const customerprice = calcprice + vat;
        this.updateCalculationFields(costpercent, factor, calcprice, vat, customerprice);
        this.setState({
            proxycostpercent: costpercent.toFixed().replace(".", ","),
            proxyfactor: (Math.round(100 * factor) / 100)
                .toString()
                .replace(".", ","),
            proxycustomerprice: customerprice.toFixed(2).replace(".", ","),
        });
    }
    recalculateVatPercent(value) {
        this.setState({ proxyvatpercent: value });
        let vatpercent = typeof value === "string" ? parseFloat(value.replace(",", ".")) : value;
        if (!!isNaN(vatpercent) || !vatpercent) {
            vatpercent = 0;
        }
        this.setState({ vatpercent: vatpercent });
        const portioncost = this.props.portionCost.current;
        const costpercent = this.state.costpercent;
        if (!costpercent ||
            costpercent === 0 ||
            !portioncost ||
            portioncost === 0) {
            return;
        }
        const factor = 100 / costpercent;
        const calcprice = portioncost * factor;
        const vat = (calcprice * vatpercent) / 100;
        const customerprice = calcprice + vat;
        this.updateCalculationFields(costpercent, factor, calcprice, vat, customerprice);
        this.setState({
            proxycostpercent: costpercent.toFixed().replace(".", ","),
            proxyfactor: (Math.round(100 * factor) / 100)
                .toString()
                .replace(".", ","),
            proxycalcprice: calcprice.toFixed(2).replace(".", ","),
            proxycustomerprice: customerprice.toFixed(2).replace(".", ","),
        });
    }
    recalculateCustomerPrice(value) {
        const portioncost = this.props.portionCost.current;
        this.setState({ proxycustomerprice: value });
        let customerprice = typeof value === "string" ? parseFloat(value.replace(",", ".")) : value;
        if (!!isNaN(customerprice) ||
            (!customerprice && !portioncost && !!isNaN(portioncost)) ||
            customerprice <= portioncost ||
            portioncost === 0) {
            return;
        }
        const vatpercent = !!isNaN(this.state.vatpercent)
            ? 0
            : this.state.vatpercent;
        const calcprice = customerprice / (1 + vatpercent / 100);
        const factor = calcprice / portioncost;
        const costpercent = 100 / factor;
        const vat = (calcprice * vatpercent) / 100;
        this.updateCalculationFields(costpercent, factor, calcprice, vat, customerprice);
        this.setState({
            proxycostpercent: costpercent.toFixed().replace(".", ","),
            proxyfactor: (Math.round(100 * factor) / 100)
                .toString()
                .replace(".", ","),
            proxycalcprice: calcprice.toFixed(2).replace(".", ","),
        });
    }
    render() {
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("div", null,
                React.createElement("label", null,
                    React.createElement("span", null, translate("/Recipe/Calculation/IngredientCost")),
                    React.createElement(Price, Object.assign({ className: styles.price }, this.props.portionCost, { 
                        //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        //@ts-ignore
                        size: "large" })))),
            React.createElement("div", null,
                React.createElement("label", null,
                    React.createElement("div", null,
                        React.createElement(Input, { label: translate("/Recipe/Calculation/IngredientPercent"), type: "text", name: "costPercent", value: this.state.proxycostpercent, ref: (el) => (this.costPercent = el), maxLength: 5, onChange: (e) => this.recalculateCostPercent(e.target.value) }),
                        React.createElement("span", { className: styles.symbol }, "%")))),
            React.createElement("div", null,
                React.createElement("label", null,
                    React.createElement("div", null,
                        React.createElement(Input, { label: translate("/Recipe/Calculation/Factor"), type: "text", name: "factor", value: this.state.proxyfactor, ref: (el) => (this.factor = el), maxLength: 5, onChange: (e) => this.recalculateFactor(e.target.value) })))),
            React.createElement("div", null,
                React.createElement("label", null,
                    React.createElement("div", null,
                        React.createElement(Input, { label: translate("/Recipe/Calculation/CalculationPrice"), type: "text", name: "calcPrice", value: this.state.proxycalcprice, ref: (el) => (this.calcPrice = el), onChange: (e) => this.recalculateCalcPrice(e.target.value) }),
                        React.createElement("span", { className: styles.symbol }, translate("/Price/CurrencySymbol"))))),
            React.createElement("div", { className: styles.vatWrapper },
                React.createElement("label", null,
                    React.createElement("div", { className: styles.vat },
                        React.createElement("div", { className: styles.vatInput },
                            React.createElement(Input, { label: translate("/Recipe/Calculation/Vat"), type: "text", name: "vat", value: this.state.proxyvatpercent, ref: (el) => (this.vat = el), maxLength: 5, onChange: (e) => this.recalculateVatPercent(e.target.value) }),
                            React.createElement("span", { className: styles.symbol }, "%")),
                        React.createElement("div", { className: styles.vatCalculated },
                            this.state.vat && this.state.vat.toFixed(2).replace(".", ","),
                            " ",
                            translate("/Price/CurrencySymbol"))))),
            React.createElement("div", null,
                React.createElement("label", null,
                    React.createElement("div", null,
                        React.createElement(Input, { label: translate("/Recipe/Calculation/CustomerPrice"), type: "text", name: "customerPrice", value: this.state.proxycustomerprice, ref: (el) => (this.customerPrice = el), onChange: (e) => this.recalculateCustomerPrice(e.target.value) }),
                        React.createElement("span", { className: styles.symbol }, translate("/Price/CurrencySymbol")))))));
    }
}
export default connect((state) => ({
    isLoggedIn: state.currentUser.isLoggedIn,
}))(Calculation);
